import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox",
  "use": "checkbox-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"checkbox\"><rect fill=\"#f4f4f4\" fill-rule=\"evenodd\" height=\"13\" rx=\"2\" stroke=\"#d8d8d8\" width=\"13\" x=\".5\" y=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id